module.exports = __webpack_public_path__ + "img/lumper-service-no.7517ae70.svg";